export const EXECUTOR = 'Executor';
export const COLABORADOR = 'Colaborador';
export const LIDER = 'Líder';
export const AUTONOMO = 'Autônomo';
export const EMPREENDEDOR = 'Empreendedor';
